import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Topbar } from './components';
const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 64,
    height: '100%'
  },
  content: {
    height: '100%'
  }
}));
const MobileNoSideMenuLayout = (props) => {
  const { children } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Topbar />
      <main className={classes.content}>{children}</main>
    </div>
  );
};
MobileNoSideMenuLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export default MobileNoSideMenuLayout;
